export const actualStep = {
  'label-img': 1,
  'product-img': 2,
  alias: 3,
  completed: 4,
};
export const totalSteps = 3;
